const choiceFieldDictionary = {
  choiceField: {
    createNew: {
      confirmButtonText: "OK",
      cancelButtonText: "Cancel",
      dialogTitle: "New item"
    }
  }
};
export {
  choiceFieldDictionary
};
//# sourceMappingURL=choiceFieldDictionary.js.map
